<div class="container-fluid d-flex flex-column h-100">
  <div class="page-head">
    <h1 class="page-title">{{ title }}</h1>
    <div class="action-row">
      <button class="btn btn-primary" (click)="addContract()">
        Add contract
      </button>
    </div>
  </div>

  <div class="row my-3 flex-grow-1">
    <div class="col">
      <app-contracts-grid
        [gridName]="'ClientContracts'"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [suppliedQueryData]="suppliedQueryData"
        [reloadGridData]="reloadGridData"
        [FilterModel]="FilterModel"
        (actionEvent)="action($event)"
        [getCalculatedColumnActions]="calculatedColumnActions"
        (resetAllResultFilters)="onResetFilters($event)"
      ></app-contracts-grid>
    </div>
  </div>
</div>
